import React, { type ReactNode } from "react";
import { Button, ButtonProps } from "react-bootstrap";

import "./PrimaryActionButton.scss";
import { ThemeVariant } from "../../../utils/constants/generic-types";

export type IPrimaryActionButtonProps = Omit<
  ButtonProps,
  "children" | "size"
> & {
  text: ReactNode;
  leftImage?: React.ReactNode;
  rightImage?: React.ReactNode;
  buttonClassName?: string;
  imgClassName?: string;
  isExternal?: boolean;
  size?: "sm" | "md" | "lg";
  theme?: ThemeVariant;
};

function PrimaryActionButton({
  text,
  onClick,
  disabled,
  isExternal,
  leftImage,
  rightImage,
  imgClassName,
  buttonClassName = "",
  size = "md",
  ...restProps
}: IPrimaryActionButtonProps) {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
      className={`PrimaryButton ${buttonClassName}`}
      {...restProps}
    >
      {leftImage && (
        <span className="leftImage">
          {typeof leftImage === "string" ? (
            <img
              className={` ${imgClassName}`}
              src={leftImage}
              alt="button_image"
            />
          ) : (
            leftImage
          )}{" "}
        </span>
      )}
      {text}{" "}
      {rightImage && (
        <span className="rightImage">
          {typeof rightImage === "string" ? (
            <img
              className={` ${imgClassName}`}
              src={rightImage}
              alt="button_image"
            />
          ) : (
            rightImage
          )}{" "}
        </span>
      )}
    </Button>
  );
}

export default PrimaryActionButton;
